import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  invoices: [], // List of all invoices
  invoice: {}, // Selected or currently editing invoice
  filters: {
    service: "", // Filter by service type
    startDate: "", // Filter by start date
    endDate: "", // Filter by end date
    search: "", // Search filter
  },
  status: "", // To track status of async actions like 'loading', 'success', 'error'
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setInvoices: (state, action) => {
      state.invoices = action.payload;
    },
    setInvoiceData: (state, action) => {
      state.invoice = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },

    addInvoice: (state, action) => {
      state.invoices.push(action.payload);
    },
    updateInvoiceSlice: (state, action) => {
      const index = state.invoices.findIndex(
        (invoice) => invoice.id === action.payload.id
      );
      if (index !== -1) {
        state.invoices[index] = action.payload;
      }
    },
    deleteInvoices: (state, action) => {
      const idsToDelete = action.payload;
      state.invoices = state.invoices.filter(
        (invoice) => !idsToDelete.includes(invoice.id)
      );
    },
    setStatus: (state, action) => {
      state.status = action.payload; // Set status like 'loading', 'success', or 'error'
    },
    clearInvoiceData: (state) => {
      state.invoice = {}; // Clear the selected or editing invoice
    },
  },
});

export const {
  setInvoices,
  setInvoiceData,
  setFilters,
  clearFilters,
  addInvoice,
  updateInvoiceSlice,
  deleteInvoices,
  setStatus,
  clearInvoiceData,
} = invoiceSlice.actions;

export default invoiceSlice.reducer;
